module.exports = __webpack_public_path__ + "static/img/4986_phase_function_Paper_PointsHejduk_Prediction.fd6ba81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4986_phase_function_Paper_PointsHejduk_Prediction.png
// module id = IGXe
// module chunks = 0